<template>
  <v-container grid-list-xl fluid>
    <div 
      v-if="load"
      class="text-xs-center">
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
    <v-form
      v-if="!load"
      ref="form"
      v-model="form.valid"
      lazy-validation
    >
      <v-text-field
        v-model="destinyAux.id"
        label="Id"
        type="number"
        required
      ></v-text-field>
      <v-text-field
        v-model="destinyAux.name"
        :counter="50"
        :rules="form.nameRules"
        label="Nome"
        required
      ></v-text-field>
      <v-text-field
        v-model="destinyAux.description"
        label="Descrição"
        :counter="255"
        required
      ></v-text-field>
      <v-btn
        :disabled="!form.valid ? true : (form.valid && saving ? true : false)"
        color="success"
        @click="saveAuxDestiny"
      >
        Salvar 
        <v-progress-circular
          v-if="saving"
          :size="20"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-btn>
    </v-form>
      
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon> 
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>    
  </v-container>
</template>

<script>
import appApi from '../../../plugins/api';
import DialogModal from '../../../components/DialogModal'
import { setTimeout } from 'timers';

export default {
  components: {
  
  },
  data: function() {
    return {
      id : null,
      saving : false,
      load : true,
      destinyAux : {
        id: null,
        name : '',
        description : ''
      },
      form : {
        valid: true,
        nameRules: [
          v => !!v || 'Nome é obrigatŕio',
          v => (v && v.length <= 255) || 'Nome tem que ter menos de 255 caracteres'
        ]
      },
      snackbar : {}
    }
  },

  computed: {
    
  },

  mounted: function() {
    if (this.$route.params.id) {
      appApi.getAuxDestiny(this.$route.params.id).then( result => {
        this.id = result.data.id
        this.destinyAux = result.data;
        this.load = false;
      });
    } else {
      this.load = false;
    }
  },

  methods: {
    saveAuxDestiny: function() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        if (this.id) {
          appApi.putAuxDestiny(this.destinyAux.id, this.destinyAux).then(result => {
            this.successMesage();
          }).catch(error => {
            console.log('error', error);
            this.errorMessage();
          });
        } else {
          appApi.postAuxDestiny(this.destinyAux).then(result => {
            this.successMesage();
            setTimeout(()=> {
              this.$router.push({ name: 'AuxDestinyEdit', params: { id: result.data.id }})  
            }, 2000);
          }).catch(error => {
            console.log('error', error);
            this.errorMessage();
          });
        }
      }
    },

    successMesage() {
      this.saving = false;
      this.snackbar = {
        show: true,
        color: "green",
        text: "Salvo com sucesso."
      };
    },

    errorMessage() {
      this.saving = false;
      this.snackbar = {
        show: true,
        color: "error",
        text: "Erro ao salvar, por favor verique os erros."
      };
    }
   }

};
</script>
<style scoped lang="css">
</style>

